import { useCallback } from 'react'

import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { Modal } from 'govwell-ui'

import { useDeleteAIChatbotFAQMutation } from 'src/fetch/aiChatbotFAQ'
import { RefetchFnType } from 'src/types'

type Props = {
  id: number
  onClose: () => void
  refetch: RefetchFnType
}
const DeleteCustomAnswerModal = ({ id, onClose, refetch }: Props) => {
  const { mutateAsync: deleteAIChatbotFAQ } = useDeleteAIChatbotFAQMutation()
  const handleDelete = useCallback(async () => {
    await deleteAIChatbotFAQ({ id })
    await refetch()
  }, [deleteAIChatbotFAQ, id, refetch])
  return (
    <Modal onClose={onClose}>
      <Modal.Header icon={faTrash}>Delete Custom Answer</Modal.Header>
      <Modal.Content>Are you sure you want to delete this custom answer?</Modal.Content>
      <Modal.Footer isDestructive confirmText="Delete custom answer" onConfirm={handleDelete} />
    </Modal>
  )
}

export default React.memo(DeleteCustomAnswerModal)
